import React, { FC } from 'react'
import { Redirect } from 'react-router-dom'
import { ChasingDots } from 'styled-spinkit'

import { AccessLevel } from '../../types'
import { useStoreOpenBotIdToAppSlice } from '../../store/app/hooks/useStoreOpenBotIdToAppSlice'
import { useOpenBotId } from '../../store/app'
import { endpointHelpers } from '../../features/serverBots/endpointHelpers'
import { useAppTheme } from '../../defaultTheme'
import { useAccessLevel } from '../../store/user'

export const WithAuth: FC<{ botId: string | undefined }> = ({ botId, children }) => {
  useStoreOpenBotIdToAppSlice(botId)
  const botIdFromStore = useOpenBotId()
  const permissionsResult = endpointHelpers.getCurrentUserPermissionsForCurrentBot.useQuery()
  const arePermissionsLoading = !permissionsResult.data && permissionsResult.isLoading // may not equal to permissionsResult.isLoading due to manual cache injection (rehydrateQueryResultFromCache)

  const theme = useAppTheme()
  const accessLevel = useAccessLevel()

  if (!isAuthenticated(accessLevel)) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { referrer: window.location.pathname, search: window.location.search }
        }}
      />
    )
  }

  if (botId !== botIdFromStore || arePermissionsLoading) {
    return <ChasingDots color={theme?.loading} data-test="auth-loader" />
  }

  return <>{children}</>
}
const isAuthenticated = (accessLevel: AccessLevel) => {
  return accessLevel.isLoggedIn && accessLevel.verifiedEmail
}
